import type { ComponentSchema } from "../../../../../schema-types"
import { primaryButtonFields, outlineButtonFields } from "../shared/button-schema-fields"

export const schema: ComponentSchema = {
  type: 'recent-products',
  label: 'Recently Viewed Products',
  description: 'A horizontal slider of products the visitor has recently viewed (stored in localStorage — no API call).',
  supportedPages: ['home', 'shop', 'product', 'category', 'cart'],
  variants: [{ id: 'v1', label: 'V1 (Horizontal Slider)' }],
  commonFields: [
    { key: 'title', label: 'Section Title', type: 'string', default: 'Recently Viewed' },
    {
      key: 'productCardVariant',
      label: 'Product Card Style',
      type: 'select',
      options: [
        { label: 'Standard (V1)', value: 'v1' },
        { label: 'Clean (V2)', value: 'v2' },
      ],
      default: 'v1',
    },
    ...primaryButtonFields('buttons.orderNow', 'Order Now Button'),
    ...outlineButtonFields('buttons.addToCart', 'Add to Cart Button'),
  ],
}
